export interface Comic {
  id: string;
  title: string;
  author: string;
  cover: string;
  description: string;
  category: string;
  categorySlug: string;
  status: '连载中' | '已完结';
  rating: number;
  views: number;
  chapters: Chapter[];
  tags: string[];
  updatedAt: string;
  isHot: boolean;
  isNew: boolean;
}

export interface Chapter {
  id: string;
  title: string;
  number: number;
  updatedAt: string;
}

export interface Category {
  name: string;
  slug: string;
  icon: string;
  description: string;
}

export const categories: Category[] = [
  { name: '全部', slug: 'all', icon: 'ri-apps-line', description: '浏览全部韩漫作品' },
  { name: '恋爱', slug: 'romance', icon: 'ri-heart-line', description: '甜蜜浪漫的爱情故事' },
  { name: '奇幻', slug: 'fantasy', icon: 'ri-magic-line', description: '充满想象力的奇幻世界' },
  { name: '动作', slug: 'action', icon: 'ri-sword-line', description: '热血刺激的动作冒险' },
  { name: '悬疑', slug: 'mystery', icon: 'ri-search-eye-line', description: '扣人心弦的悬疑推理' },
  { name: '搞笑', slug: 'comedy', icon: 'ri-emotion-laugh-line', description: '轻松愉快的搞笑日常' },
  { name: '耽美', slug: 'bl', icon: 'ri-heart-2-line', description: '唯美动人的BL故事' },
  { name: '剧情', slug: 'drama', icon: 'ri-film-line', description: '深刻精彩的剧情佳作' },
];

export const comics: Comic[] = [
  {
    id: '1',
    title: '星辰之海',
    author: '金秀雅',
    cover: 'https://readdy.ai/api/search-image?query=A%20beautiful%20Korean%20manhwa%20cover%20style%20illustration%20of%20a%20young%20woman%20with%20flowing%20dark%20hair%20against%20a%20starry%20night%20sky%20backdrop%2C%20soft%20watercolor%20texture%2C%20romantic%20atmosphere%2C%20clean%20composition%20with%20warm%20golden%20accents%2C%20Korean%20webtoon%20art%20style%2C%20delicate%20facial%20features%2C%20dreamy%20lighting&width=800&height=1100&seq=comic-cover-01&orientation=portrait',
    description: '在一个被星辰之力笼罩的世界里，少女艾琳意外发现自己拥有操控星辰的古老能力。在命运的指引下，她踏上寻找真相的旅程，邂逅了神秘的黑夜少年。两人之间展开了跨越时空的浪漫冒险。唯美的画风与宏大的世界观交织，带你进入璀璨的星辰之海。',
    category: '奇幻',
    categorySlug: 'fantasy',
    status: '连载中',
    rating: 4.8,
    views: 2356000,
    tags: ['奇幻', '恋爱', '冒险', '异能'],
    updatedAt: '2026-08-05',
    isHot: true,
    isNew: false,
    chapters: [
      { id: 'c1-1', title: '第1话 星辰的觉醒', number: 1, updatedAt: '2026-01-15' },
      { id: 'c1-2', title: '第2话 黑夜中的相遇', number: 2, updatedAt: '2026-01-22' },
      { id: 'c1-3', title: '第3话 古老的预言', number: 3, updatedAt: '2026-01-29' },
      { id: 'c1-4', title: '第4话 试炼之路', number: 4, updatedAt: '2026-02-05' },
      { id: 'c1-5', title: '第5话 命运的齿轮', number: 5, updatedAt: '2026-02-12' },
    ],
  },
  {
    id: '2',
    title: '甜心契约',
    author: '李恩智',
    cover: 'https://readdy.ai/api/search-image?query=A%20Korean%20manhwa%20cover%20illustration%20of%20a%20couple%20in%20a%20sweet%20embrace%2C%20cherry%20blossom%20petals%20falling%20around%20them%2C%20soft%20pink%20and%20cream%20color%20palette%2C%20romantic%20atmosphere%2C%20Korean%20webtoon%20art%20style%2C%20clean%20composition%2C%20gentle%20expressions%2C%20modern%20school%20setting&width=800&height=1100&seq=comic-cover-02&orientation=portrait',
    description: '校园里的完美学长竟然提出了一个无法拒绝的契约——假扮他的女友三个月！普通女孩韩素希的生活从此天翻地覆。甜蜜又搞笑的契约恋爱就此展开，当假戏真做时，心跳的节奏再也藏不住。',
    category: '恋爱',
    categorySlug: 'romance',
    status: '连载中',
    rating: 4.6,
    views: 1890000,
    tags: ['恋爱', '校园', '搞笑', '契约'],
    updatedAt: '2026-08-04',
    isHot: true,
    isNew: false,
    chapters: [
      { id: 'c2-1', title: '第1话 突如其来的契约', number: 1, updatedAt: '2026-02-10' },
      { id: 'c2-2', title: '第2话 第一次约会', number: 2, updatedAt: '2026-02-17' },
      { id: 'c2-3', title: '第3话 心跳加速', number: 3, updatedAt: '2026-02-24' },
    ],
  },
  {
    id: '3',
    title: '暗夜追踪者',
    author: '朴志勋',
    cover: 'https://readdy.ai/api/search-image?query=A%20dark%20and%20moody%20Korean%20manhwa%20cover%20illustration%20of%20a%20detective%20in%20a%20long%20coat%20standing%20in%20rainy%20alley%2C%20noir%20style%2C%20dramatic%20lighting%2C%20urban%20night%20scene%2C%20Korean%20webtoon%20art%20style%2C%20mysterious%20atmosphere%2C%20cool%20gray%20and%20blue%20tones%2C%20clean%20composition&width=800&height=1100&seq=comic-cover-03&orientation=portrait',
    description: '首尔夜晚的街头，一连串离奇的失踪案件让整座城市陷入恐慌。退役特种兵韩泰镇成为了私家侦探，在追查真相的过程中，他发现了一个隐藏在都市阴影下的庞大犯罪网络。每一步都危机四伏，每一个线索都通向更深的黑暗。',
    category: '悬疑',
    categorySlug: 'mystery',
    status: '连载中',
    rating: 4.7,
    views: 1560000,
    tags: ['悬疑', '动作', '犯罪', '都市'],
    updatedAt: '2026-08-03',
    isHot: true,
    isNew: false,
    chapters: [
      { id: 'c3-1', title: '第1话 雨夜失踪', number: 1, updatedAt: '2026-03-01' },
      { id: 'c3-2', title: '第2话 第一个线索', number: 2, updatedAt: '2026-03-08' },
    ],
  },
  {
    id: '4',
    title: '魔王大小姐',
    author: '崔宥娜',
    cover: 'https://readdy.ai/api/search-image?query=A%20Korean%20manhwa%20cover%20illustration%20of%20a%20noble%20lady%20with%20long%20silver%20hair%20in%20an%20elegant%20gown%2C%20holding%20a%20magical%20staff%2C%20fantasy%20castle%20background%2C%20royal%20and%20magical%20atmosphere%2C%20Korean%20webtoon%20art%20style%2C%20vibrant%20warm%20colors%2C%20clean%20composition%2C%20regal%20expression&width=800&height=1100&seq=comic-cover-04&orientation=portrait',
    description: '被誉为帝国最可怕的魔王，其实是个被诅咒的贵族大小姐艾琳诺。白天她是高贵的名门淑女，夜晚却要面对体内汹涌的魔力。当邻国王子以联姻之名闯入她的生活，一段充满魔法、阴谋与爱情的华丽冒险就此展开。',
    category: '奇幻',
    categorySlug: 'fantasy',
    status: '连载中',
    rating: 4.5,
    views: 1320000,
    tags: ['奇幻', '恋爱', '魔法', '贵族'],
    updatedAt: '2026-08-05',
    isHot: false,
    isNew: false,
    chapters: [
      { id: 'c4-1', title: '第1话 魔王的日常', number: 1, updatedAt: '2026-04-01' },
      { id: 'c4-2', title: '第2话 邻国王子', number: 2, updatedAt: '2026-04-08' },
      { id: 'c4-3', title: '第3话 舞会风波', number: 3, updatedAt: '2026-04-15' },
    ],
  },
  {
    id: '5',
    title: '无限格斗',
    author: '姜太元',
    cover: 'https://readdy.ai/api/search-image?query=A%20Korean%20manhwa%20cover%20illustration%20of%20a%20fighter%20in%20dynamic%20action%20pose%2C%20martial%20arts%20theme%2C%20intense%20expression%2C%20urban%20street%20fighting%20backdrop%2C%20explosive%20energy%20effects%2C%20Korean%20webtoon%20art%20style%2C%20warm%20orange%20and%20red%20tones%2C%20clean%20composition%2C%20powerful%20stance&width=800&height=1100&seq=comic-cover-05&orientation=portrait',
    description: '地下格斗界的传奇人物金斗焕，为了寻找失踪的妹妹而重返格斗擂台。每一场战斗都是一次生死考验，每一个对手背后都藏着秘密。热血的格斗场面与扣人心弦的寻亲故事交织，带你感受拳拳到肉的震撼。',
    category: '动作',
    categorySlug: 'action',
    status: '连载中',
    rating: 4.4,
    views: 1100000,
    tags: ['动作', '格斗', '热血', '寻亲'],
    updatedAt: '2026-08-04',
    isHot: false,
    isNew: false,
    chapters: [
      { id: 'c5-1', title: '第1话 重返擂台', number: 1, updatedAt: '2026-04-20' },
      { id: 'c5-2', title: '第2话 首战告捷', number: 2, updatedAt: '2026-04-27' },
    ],
  },
  {
    id: '6',
    title: '蓝色微风',
    author: '韩彩英',
    cover: 'https://readdy.ai/api/search-image?query=A%20Korean%20manhwa%20cover%20illustration%20of%20two%20young%20men%20sharing%20a%20tender%20moment%20by%20the%20seaside%2C%20gentle%20blue%20and%20white%20color%20palette%2C%20breeze%20blowing%20through%20hair%2C%20emotional%20atmosphere%2C%20Korean%20webtoon%20BL%20art%20style%2C%20clean%20composition%2C%20summer%20vibes&width=800&height=1100&seq=comic-cover-06&orientation=portrait',
    description: '海边小镇的夏天，音乐少年尹在浩遇见了从首尔来度假的钢琴天才车恩宇。相同的音乐梦想让两人迅速靠近，在蓝色海风的见证下，一段纯粹而唯美的青春恋曲悄然奏响。',
    category: '耽美',
    categorySlug: 'bl',
    status: '已完结',
    rating: 4.9,
    views: 2100000,
    tags: ['耽美', '音乐', '青春', '治愈'],
    updatedAt: '2026-07-30',
    isHot: true,
    isNew: false,
    chapters: [
      { id: 'c6-1', title: '第1话 海边的相遇', number: 1, updatedAt: '2026-05-10' },
      { id: 'c6-2', title: '第2话 共同的旋律', number: 2, updatedAt: '2026-05-17' },
      { id: 'c6-3', title: '第3话 心动的音符', number: 3, updatedAt: '2026-05-24' },
      { id: 'c6-4', title: '第4话 夏日终曲', number: 4, updatedAt: '2026-05-31' },
    ],
  },
  {
    id: '7',
    title: '办公室生存记',
    author: '金敏瑞',
    cover: 'https://readdy.ai/api/search-image?query=A%20Korean%20manhwa%20cover%20illustration%20of%20an%20office%20worker%20with%20a%20funny%20exhausted%20expression%2C%20surrounded%20by%20floating%20documents%20and%20coffee%20cups%2C%20comedic%20style%2C%20bright%20and%20playful%20colors%2C%20Korean%20webtoon%20art%20style%2C%20clean%20composition%2C%20humorous%20tone&width=800&height=1100&seq=comic-cover-07&orientation=portrait',
    description: '职场新人李多喜的理想很丰满，现实却很骨感。奇葩同事、挑剔上司、加不完的班...每天都是一场生存挑战！用幽默搞笑的笔触描绘当代职场人的酸甜苦辣，每一个社畜都能从中找到自己的影子。',
    category: '搞笑',
    categorySlug: 'comedy',
    status: '连载中',
    rating: 4.3,
    views: 980000,
    tags: ['搞笑', '职场', '日常', '生活'],
    updatedAt: '2026-08-05',
    isHot: false,
    isNew: true,
    chapters: [
      { id: 'c7-1', title: '第1话 第一天上班', number: 1, updatedAt: '2026-06-01' },
      { id: 'c7-2', title: '第2话 社畜的日常', number: 2, updatedAt: '2026-06-08' },
      { id: 'c7-3', title: '第3话 加班地狱', number: 3, updatedAt: '2026-06-15' },
    ],
  },
  {
    id: '8',
    title: '时光旅人',
    author: '尹瑞镇',
    cover: 'https://readdy.ai/api/search-image?query=A%20Korean%20manhwa%20cover%20illustration%20of%20a%20man%20stepping%20through%20a%20portal%20of%20light%2C%20clock%20gears%20floating%20around%2C%20time%20travel%20theme%2C%20warm%20golden%20and%20sepia%20tones%2C%20mysterious%20atmosphere%2C%20Korean%20webtoon%20art%20style%2C%20clean%20composition%2C%20nostalgic%20feel&width=800&height=1100&seq=comic-cover-08&orientation=portrait',
    description: '普通上班族朴俊宇偶然获得了一块能够穿越时空的怀表。他可以回到过去改变遗憾，也可以去未来窥探命运。但每一次时间旅行都伴随着不可预知的代价，当他试图拯救逝去的爱人时，时间线的崩塌悄然开始。',
    category: '剧情',
    categorySlug: 'drama',
    status: '连载中',
    rating: 4.7,
    views: 1450000,
    tags: ['剧情', '科幻', '时空', '爱情'],
    updatedAt: '2026-08-02',
    isHot: true,
    isNew: false,
    chapters: [
      { id: 'c8-1', title: '第1话 旧物店的怀表', number: 1, updatedAt: '2026-06-20' },
      { id: 'c8-2', title: '第2话 第一次穿越', number: 2, updatedAt: '2026-06-27' },
      { id: 'c8-3', title: '第3话 蝴蝶效应', number: 3, updatedAt: '2026-07-04' },
    ],
  },
  {
    id: '9',
    title: '花店老板的秘密',
    author: '宋智恩',
    cover: 'https://readdy.ai/api/search-image?query=A%20Korean%20manhwa%20cover%20illustration%20of%20a%20beautiful%20woman%20surrounded%20by%20colorful%20flowers%20in%20a%20charming%20flower%20shop%2C%20warm%20sunlight%20streaming%20through%20windows%2C%20soft%20pastel%20colors%2C%20Korean%20webtoon%20art%20style%2C%20clean%20composition%2C%20gentle%20and%20calming%20atmosphere&width=800&height=1100&seq=comic-cover-09&orientation=portrait',
    description: '小巷深处的花店里，美丽的花店老板林智雅总是带着温柔的微笑。但没有人知道，每一束从她手中售出的鲜花都藏着一个秘密——它们能让人做一场真实的梦。当一位失忆的客人找上门来，花店背后隐藏的奇幻世界逐渐浮出水面。',
    category: '剧情',
    categorySlug: 'drama',
    status: '连载中',
    rating: 4.6,
    views: 870000,
    tags: ['剧情', '奇幻', '治愈', '日常'],
    updatedAt: '2026-08-05',
    isHot: false,
    isNew: true,
    chapters: [
      { id: 'c9-1', title: '第1话 巷子里的花店', number: 1, updatedAt: '2026-07-01' },
      { id: 'c9-2', title: '第2话 特别的花束', number: 2, updatedAt: '2026-07-08' },
    ],
  },
  {
    id: '10',
    title: '狂暴战神',
    author: '张赫宰',
    cover: 'https://readdy.ai/api/search-image?query=A%20Korean%20manhwa%20cover%20illustration%20of%20a%20fierce%20warrior%20with%20battle%20scars%2C%20holding%20a%20massive%20sword%2C%20epic%20battlefield%20background%20with%20flames%2C%20intense%20and%20powerful%20composition%2C%20Korean%20webtoon%20art%20style%2C%20dark%20red%20and%20orange%20dramatic%20lighting&width=800&height=1100&seq=comic-cover-10&orientation=portrait',
    description: '曾经被称为战神的雇佣兵韩烈，为了守护心爱之人，不惜与世界为敌。在被背叛、被抛弃之后，他浴火重生，以更强大的姿态归来。一部热血澎湃的复仇史诗，拳拳到肉的打斗场面让人肾上腺素飙升。',
    category: '动作',
    categorySlug: 'action',
    status: '连载中',
    rating: 4.5,
    views: 1780000,
    tags: ['动作', '热血', '复仇', '异能'],
    updatedAt: '2026-08-04',
    isHot: false,
    isNew: false,
    chapters: [
      { id: 'c10-1', title: '第1话 战神的陨落', number: 1, updatedAt: '2026-07-15' },
      { id: 'c10-2', title: '第2话 重生之路', number: 2, updatedAt: '2026-07-22' },
      { id: 'c10-3', title: '第3话 归来之战', number: 3, updatedAt: '2026-07-29' },
    ],
  },
  {
    id: '11',
    title: '樱花树下的约定',
    author: '朴美英',
    cover: 'https://readdy.ai/api/search-image?query=A%20Korean%20manhwa%20cover%20illustration%20of%20a%20young%20couple%20under%20a%20blooming%20cherry%20blossom%20tree%2C%20spring%20atmosphere%2C%20soft%20pink%20petals%2C%20romantic%20and%20tender%20mood%2C%20Korean%20webtoon%20art%20style%2C%20clean%20composition%2C%20youthful%20and%20fresh%20feeling&width=800&height=1100&seq=comic-cover-11&orientation=portrait',
    description: '高中毕业那年，朴志浩和崔秀雅在樱花树下许下了永远的约定。十年后，当命运让他们再次相遇，那些少年时代的心动还能否重新绽放？一部温暖治愈的纯爱故事，带你回到最美好的青春时光。',
    category: '恋爱',
    categorySlug: 'romance',
    status: '已完结',
    rating: 4.8,
    views: 1920000,
    tags: ['恋爱', '青春', '重逢', '治愈'],
    updatedAt: '2026-07-28',
    isHot: false,
    isNew: false,
    chapters: [
      { id: 'c11-1', title: '第1话 春天的约定', number: 1, updatedAt: '2026-01-01' },
      { id: 'c11-2', title: '第2话 十年之后', number: 2, updatedAt: '2026-01-08' },
      { id: 'c11-3', title: '第3话 再次心动', number: 3, updatedAt: '2026-01-15' },
      { id: 'c11-4', title: '第4话 樱花再开', number: 4, updatedAt: '2026-01-22' },
      { id: 'c11-5', title: '第5话 永远在一起', number: 5, updatedAt: '2026-01-29' },
    ],
  },
  {
    id: '12',
    title: '猫咪咖啡厅',
    author: '李瑞妍',
    cover: 'https://readdy.ai/api/search-image?query=A%20Korean%20manhwa%20cover%20illustration%20of%20a%20cozy%20cat%20cafe%20scene%2C%20cute%20cats%20playing%20around%20a%20smiling%20barista%2C%20warm%20and%20inviting%20atmosphere%2C%20soft%20cream%20and%20brown%20tones%2C%20Korean%20webtoon%20art%20style%2C%20clean%20composition%2C%20comforting%20and%20wholesome%20vibe&width=800&height=1100&seq=comic-cover-12&orientation=portrait',
    description: '社畜金智恩辞职后在巷子里开了一家猫咪咖啡厅。在这里，她遇见了各种各样的人和猫——失意的作家、迷路的小学生、退休的老奶奶...每个客人都带着自己的故事走进这间小小的咖啡厅，而智恩和她的猫咪们用温暖治愈着每一颗疲惫的心。',
    category: '搞笑',
    categorySlug: 'comedy',
    status: '连载中',
    rating: 4.4,
    views: 760000,
    tags: ['搞笑', '治愈', '日常', '猫咪'],
    updatedAt: '2026-08-05',
    isHot: false,
    isNew: true,
    chapters: [
      { id: 'c12-1', title: '第1话 辞职开咖啡厅', number: 1, updatedAt: '2026-07-20' },
      { id: 'c12-2', title: '第2话 第一位客人', number: 2, updatedAt: '2026-07-27' },
    ],
  },
];

export function getComicsByCategory(slug: string): Comic[] {
  if (slug === 'all') return comics;
  return comics.filter((c) => c.categorySlug === slug);
}

export function getComicById(id: string): Comic | undefined {
  return comics.find((c) => c.id === id);
}

export function getHotComics(): Comic[] {
  return comics.filter((c) => c.isHot).slice(0, 6);
}

export function getNewComics(): Comic[] {
  return comics.filter((c) => c.isNew);
}

export function getLatestComics(): Comic[] {
  return [...comics].sort((a, b) => new Date(b.updatedAt).getTime() - new Date(a.updatedAt).getTime()).slice(0, 8);
}

export function getRelatedComics(comic: Comic, count: number = 4): Comic[] {
  return comics.filter((c) => c.id !== comic.id && c.categorySlug === comic.categorySlug).slice(0, count);
}